import { createFileRoute } from '@tanstack/react-router'
import { CreditCard } from 'lucide-react'
import { PaymentMethodsScreen } from '@/screens/billing/SCR-162-payment-methods'

export const Route = createFileRoute('/_app/billing/payment-methods')({
  staticData: { screen: { id: 'SCR-162', title: 'Payment methods', group: 'Organisation', perm: 'billing.manage', hidden: true, description: 'The card, UPI ID or bank mandate Razorpay charges for your plan.', icon: CreditCard } },
  component: PaymentMethodsScreen,
})
